import { Observable } from 'rxjs';
import { BaseController } from '~client/controller/base-controller';
import { AvailableSectionListResponse } from '~client/model/available-section-list-response';
import { GetSeatsUsingSectionsRequest } from '~client/model/get-seats-using-sections-request';
import { InventoryGroupingListResponse } from '~client/model/inventory-grouping-list-response';
import { ResponseEntity } from '~client/model/response-entity';
import { SwitchSelectionGroupRequest } from '~client/model/switch-selection-group-request';

/* User APIs pertaining to section and seat selection */
export class InventorySelectionController extends BaseController {
  /* Using offerGroupId, returns a list of sections and seats which have availability */
  public getSeats$(offerGroupId: string): Observable<AvailableSectionListResponse> {
    return this.get$('/marketplace/inventorySelection/public/seats', { offerGroupId });
  }

  /* Using eventId and sectionCodes, returns a list of sections and seats which have availability */
  public getSeatsUsingSections$(
    request: GetSeatsUsingSectionsRequest,
  ): Observable<AvailableSectionListResponse> {
    return this.get$(
      request.sectionCodes.reduce(
        (previousValue: string, sectionCode: string): string =>
          previousValue + `&sectionCodes=${sectionCode}`,
        `/marketplace/inventorySelection/public/seats/forSections?eventId=${request.eventId}`,
      ),
    );
  }

  /* Allows the user to switch to a different selection group for a given offer */
  public switchSelectionGroup$(request: SwitchSelectionGroupRequest): Observable<ResponseEntity> {
    return this.post$(`/marketplace/inventorySelection/selectionGroup`, request);
  }

  /* Allows the user to get possible selection groups for him to choose from */
  public getSelectionGroups$(offerId: string): Observable<InventoryGroupingListResponse> {
    return this.get$('/marketplace/inventorySelection/selectionGroups', { offerId });
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src426716145/src/modules/client/src/controller/inventory-selection-controller.ts